export default __webpack_public_path__ + "static/bg-footer-cbbe8b254588b8e15e14a2beb8aac021.jpeg";